import { useLocation } from '@/services/router/compat';
import { useIsHydraRoute } from '@/services/router/route-ownership';
import { PausedAccountBanner } from './paused-account-banner';
import { PaymentIssueBanner } from './payment-issue-banner';
import { PendingCancellationBanner } from './pending-cancellation-banner';

/**
 * The account's billing banners, in the order the embedded app shows them.
 *
 * The embedded app shows the same banners in its own header, so these show only on the pages Hydra
 * renders, and no page shows a banner twice.
 */
export function AccountBillingBanners() {
  const { pathname } = useLocation();
  const isHydraRoute = useIsHydraRoute(pathname);

  if (!isHydraRoute) {
    return null;
  }
  return (
    <>
      <PaymentIssueBanner pathname={pathname} />
      <PendingCancellationBanner />
      <PausedAccountBanner />
    </>
  );
}
